export default {
      id: "circle__speed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__speed",
      toString: function () {
        return this.url;
      }
    }